import { useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { getStudentSession } from "./quizSession";

// The "waiting" experience now lives inside QuizStudentPlay (so a single SSE
// subscription stays alive and never misses the first question). This route is
// kept only to redirect any old links to the play screen.
export default function QuizStudentWaiting() {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const student = getStudentSession(sessionId);
    const name = student?.name || searchParams.get("name") || "";
    if (student?.uuidParticipant) {
      navigate(`/quiz/session/${sessionId}/play?name=${encodeURIComponent(name)}`, { replace: true });
    } else {
      navigate(`/quiz/join/${sessionId}`, { replace: true });
    }
  }, [sessionId, navigate, searchParams]);

  return (
    <div className="flex-1 flex items-center justify-center p-5">
      <div className="w-10 h-10 border-[3px] border-darkblue border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}
